import { Route } from "react-router";
import { CREATE, MODIFY, VIEW } from "src/context/FoodpilotContext";
import { BrandCreate } from "../Brand/Create";
import { BrandEdit } from "../Brand/Edit";
import { BrandList } from "../Brand/List";
import CohortsPage from "../Cohorts";
import { CompaniesList } from "../Company/CompaniesList";
import { Company } from "../Company/Company";
import { CompanyCreate } from "../Company/CompanyCreate";
import { CompanyEdit } from "../Company/CompanyEdit";
import { IngredientLineCreate } from "../IngredientLine/Create";
import { IngredientLineEdit } from "../IngredientLine/Edit";
import { IngredientLineList } from "../IngredientLine/List";
import { JsonAttributes } from "../JsonAttributes";
import { MyOrganization } from "../MyOrganization";
import { OrganizationTypeList } from "../OrganizationTypeList";
import { PackagingsSsq } from "../Packagings/Ssq";
import { ProductLineCreate } from "../ProductLine/ProductLineCreate";
import { ProductLineEdit } from "../ProductLine/ProductLineEdit";
import { ProductLineList } from "../ProductLineList";
import { ProvidersList } from "../Supplier/ProvidersList";
import { TagOverview } from "../TagManagement/TagOverview";
import { TagTypeCreate } from "../TagManagement/TagTypeCreate";
import { TagTypeEdit } from "../TagManagement/TagTypeEdit";
import { TagTypesList } from "../TagManagement/TagTypesList";
import { TagValueCreate } from "../TagManagement/TagValueCreate";
import { TagValueEdit } from "../TagManagement/TagValueEdit";
import { TagValuesList } from "../TagManagement/TagValuesList";
import { BrandsProtection } from "./BrandsProtection";
import { CohortDefinitionsProtection } from "./CohortDefinitionsProtection";
import { OrganizationAdministrationProtection } from "./OrganizationAdministrationProtection";
import { PackagingSsqProtection } from "./PackagingSsqProtection";
import { SupplierAdministrationProtection } from "./SupplierAdministrationProtection";
import { CompanySectorListLazy } from "./lazySettingsPages";
import { SettingsRouteBoundary } from "./SettingsRouteBoundary";

export const organizationRoutes = () => (
    <>
        <Route path="my-organization" element={<MyOrganization />} />
        <Route path="my-organization/:sectionId" element={<MyOrganization />} />
        <Route path="my-organization/companies-suppliers/companies">
            <Route
                index
                element={
                    <OrganizationAdministrationProtection action={VIEW}>
                        <CompaniesList isProvider={false} />
                    </OrganizationAdministrationProtection>
                }
            />
            <Route
                path=":id"
                element={
                    <OrganizationAdministrationProtection action={VIEW}>
                        <Company />
                    </OrganizationAdministrationProtection>
                }
            />
            <Route
                path="create"
                element={
                    <OrganizationAdministrationProtection action={CREATE}>
                        <CompanyCreate isProvider={false} />
                    </OrganizationAdministrationProtection>
                }
            />
            <Route
                path=":id/edit"
                element={
                    <OrganizationAdministrationProtection action={MODIFY}>
                        <CompanyEdit isProvider={false} />
                    </OrganizationAdministrationProtection>
                }
            />
        </Route>
        <Route path="my-organization/companies-suppliers/suppliers">
            <Route
                index
                element={
                    <SupplierAdministrationProtection action={VIEW}>
                        <ProvidersList isProvider={true} />
                    </SupplierAdministrationProtection>
                }
            />
            <Route
                path="create"
                element={
                    <OrganizationAdministrationProtection action={CREATE}>
                        <CompanyCreate isProvider={true} />
                    </OrganizationAdministrationProtection>
                }
            />
            <Route
                path=":id/edit"
                element={
                    <OrganizationAdministrationProtection action={MODIFY}>
                        <CompanyEdit isProvider={true} />
                    </OrganizationAdministrationProtection>
                }
            />
        </Route>
        <Route path="my-organization/companies-suppliers/organization-types" element={<OrganizationTypeList />} />
        <Route
            path="my-organization/companies-suppliers/industry-sectors"
            element={
                <SettingsRouteBoundary>
                    <CompanySectorListLazy />
                </SettingsRouteBoundary>
            }
        />
        <Route element={<BrandsProtection />}>
            <Route path="my-organization/products-ingredients/brands">
                <Route index element={<BrandList />} />
                <Route element={<BrandsProtection action={CREATE} />}>
                    <Route path="create" element={<BrandCreate />} />
                </Route>
                <Route element={<BrandsProtection action={MODIFY} />}>
                    <Route path=":brandId/edit" element={<BrandEdit />} />
                </Route>
            </Route>
        </Route>
        <Route path="my-organization/products-ingredients/product-lines">
            <Route index element={<ProductLineList />} />
            <Route path="create" element={<ProductLineCreate />} />
            <Route path=":id/edit" element={<ProductLineEdit />} />
        </Route>
        <Route path="my-organization/products-ingredients/ingredient-sectors">
            <Route index element={<IngredientLineList />} />
            <Route path="create" element={<IngredientLineCreate />} />
            <Route path=":ingredientLineId/edit" element={<IngredientLineEdit />} />
        </Route>
        <Route element={<PackagingSsqProtection />}>
            <Route path="my-organization/packaging/packaging-qss" element={<PackagingsSsq />} />
        </Route>
        <Route path="my-organization/custom-data-taxonomies/custom-attributes" element={<JsonAttributes />} />
        <Route element={<CohortDefinitionsProtection />}>
            <Route path="my-organization/custom-data-taxonomies/cohort-definitions" element={<CohortsPage />} />
        </Route>
        <Route path="my-organization/custom-data-taxonomies/tags">
            <Route index element={<TagOverview />} />
            <Route path="types">
                <Route index element={<TagTypesList />} />
                <Route path="create" element={<TagTypeCreate />} />
                <Route path=":tagTypeId/edit" element={<TagTypeEdit />} />
            </Route>
            <Route path="values">
                <Route index element={<TagValuesList />} />
                <Route path="create" element={<TagValueCreate />} />
                <Route path=":tagValueId/edit" element={<TagValueEdit />} />
            </Route>
        </Route>
    </>
);
